import React from 'react';
import PrintingActions from './PrintingActions';

export default class PrintingTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            reverseSort: false
        };
    }

    sortTable() {
        this.setState({ reverseSort: !this.state.reverseSort });
    }

    toggleConfirmPrint(checkNumber, event) {
        const { checked } = event.target;
        const { printsCancelled, printsConfirmed } = this.props;

        this.props.markPrintsConfirmed(checked ? [...printsConfirmed, checkNumber] : printsConfirmed.filter(ck => ck !== checkNumber));
        if(checked && printsCancelled.indexOf(checkNumber) >= 0) {
            this.props.markPrintsCancelled(printsCancelled.filter(ck => ck !== checkNumber));
        }
    }

    toggleCancelPrint(checkNumber, event) {
        const { checked } = event.target;
        const { printsCancelled, printsConfirmed } = this.props;

        this.props.markPrintsCancelled(checked ? [...printsCancelled, checkNumber] : printsCancelled.filter(ck => ck !== checkNumber));
        if(checked && printsConfirmed.indexOf(checkNumber) >= 0) {
            this.props.markPrintsConfirmed(printsConfirmed.filter(ck => ck !== checkNumber));
        }
    }

    reprint(check) {
        if (this.props.printedOk.indexOf(check.checkNumber) < 0) {
            this.props.reprint([check.printJobId]);
        }
    }

    render() {
        const { checkPrints, printsCancelled, printsConfirmed } = this.props;

        return (
            <div className="table-container">
                <table className="table">
                    <thead>
                        <tr className="table-header table-row">
                            <th className="sort active">Number
                                <div className="sort-arrows relative" onClick={this.sortTable.bind(this)}>
                                    <i className="icon ion-android-arrow-dropup"></i>
                                    <i className="icon ion-android-arrow-dropdown"></i>
                                </div>
                            </th>
                            <th>Details</th>
                            <th>Reprint</th>
                            <th>Printed Okay</th>
                            <th>Cancel Printing</th>
                        </tr>
                    </thead>
                    <tbody>
                        {checkPrints.length > 0 && <PrintingActions {...this.props} />}
                        {(this.state.reverseSort ? checkPrints.reverse() : checkPrints).map(check =>
                            <tr key={check.checkNumber} className="table-row deleted">
                                <td data-label="Number">
                                    <p className="bold-text">Check #{check.checkNumber}</p>
                                </td>
                                <td data-label="Details">
                                    {check.applicationId > 0 && <p>
                                        <i className={`icon-${check.card ? "check approved" : "close error"}-text icon-left middle`}></i>
                                        Card {check.printInstructions && `- ${check.printInstructions}`}
                                        {check.signatureNeeded && <span className="accent-text3 icon-right">Signature Needed</span>}
                                    </p>}
                                </td>
                                <td data-label="Reprint">
                                    <i className={`icon-printer accent-text primary-hover ${(printsCancelled.indexOf(check.checkNumber) >= 0 || printsConfirmed.indexOf(check.checkNumber) >= 0) ? "disabled" : ""}`}
                                        onClick={this.reprint.bind(this, check)}></i>
                                </td>
                                <td data-label="Confirm Print">
                                    <div className="custom-check-container">
                                        <input type="checkbox" id={`printed-${check.checkNumber}`} className="custom-check"
                                            checked={printsConfirmed.indexOf(check.checkNumber) >= 0} onChange={this.toggleConfirmPrint.bind(this, check.checkNumber)} />
                                        <label htmlFor={`printed-${check.checkNumber}`} className="secondary-text"></label>
                                    </div>
                                </td>
                                <td data-label="Cancel Print">
                                    <div className="custom-check-container">
                                        <input type="checkbox" id={`cancel-print-${check.checkNumber}`} className="custom-check"
                                            checked={printsCancelled.indexOf(check.checkNumber) >= 0} onChange={this.toggleCancelPrint.bind(this, check.checkNumber)} />
                                        <label htmlFor={`cancel-print-${check.checkNumber}`} className="secondary-text"></label>
                                    </div>
                                </td>
                            </tr>)}
                    </tbody>
                </table>
                {!checkPrints.length && <div className="no-results"><i className="icon ion-printer"></i><span>No Print Records</span></div>}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/printingComponents/PrintingTable.jsx